export class LibraryImage {
  source: string;
  name: string;

  constructor(image: LibraryImage = null) {
    if (image == null) {
      this.source = "";
      this.name = "";
    } else {
      this.source = image.source;
      this.name = image.name;
    }
  }
}
